<div>
    <p-toast></p-toast>

    <p-scrollPanel [style]="{height: 'calc(100vh - 172px)'}">
        <div class="mg-side10">
            <div class="flex justify-content-between filter-title-block">
                <span class="filter-title">Type</span>
                <span class="uncheck-filter" (click)="uncheckServiceTypes()">Uncheck all</span>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group1" value="riderVehicleTypes.Moto" [value]="riderVehicleTypes.Moto" [(ngModel)]="selectedRiderVehicleTypes" inputId="riderVehicleTypes.Moto"></p-checkbox>
                <label for="riderVehicleTypes.Moto">Moto</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group1" value="riderVehicleTypes.Sedan" [value]="riderVehicleTypes.Sedan" [(ngModel)]="selectedRiderVehicleTypes" inputId="riderVehicleTypes.Sedan"></p-checkbox>
                <label for="riderVehicleTypes.Sedan">Sedan</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group1" value="riderVehicleTypes.SUV" [value]="riderVehicleTypes.SUV" [(ngModel)]="selectedRiderVehicleTypes" inputId="riderVehicleTypes.SUV"></p-checkbox>
                <label for="riderVehicleTypes.SUV">SUV</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group1" value="riderVehicleTypes.PetTaxi" [value]="riderVehicleTypes.PetTaxi" [(ngModel)]="selectedRiderVehicleTypes" inputId="riderVehicleTypes.PetTaxi"></p-checkbox>
                <label for="riderVehicleTypes.PetTaxi">Pet taxi</label>
            </div>
        </div>

        <div class="mb-4 mg-side10">
            <div class="flex justify-content-between filter-title-block">
                <span class="filter-title">Value</span>
            </div>
            <div class="flex justify-content-between mb-4">
                <span>₱ {{minMaxRangeValue[0]}}</span>
                <span>₱ {{minMaxRangeValue[1]}}</span>
            </div>
            <div class="mg-side5">
                <p-slider [(ngModel)]="minMaxRangeValue" [min]="minRangeValue" [max]="maxRangeValue" [range]="true"></p-slider>
            </div>
        </div>

        <div class="mg-side10">
            <div class="flex justify-content-between filter-title-block">
                <span class="filter-title">Status</span>
                <span class="uncheck-filter" (click)="uncheckDeliveryStatuses()">Uncheck all</span>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group2" value="deliveryStatuses.RiderAssigning" [value]="deliveryStatuses.RiderAssigning" [(ngModel)]="selectedDeliveryStatuses" inputId="deliveryStatuses.RiderAssigning"></p-checkbox>
                <label for="deliveryStatuses.RiderAssigning">Searching</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group2" value="deliveryStatuses.DepartedToPickup" [value]="deliveryStatuses.DepartedToPickup" [(ngModel)]="selectedDeliveryStatuses" inputId="deliveryStatuses.DepartedToPickup"></p-checkbox>
                <label for="deliveryStatuses.DepartedToPickup">On the way</label>
            </div>
            <div class="field-checkbox">
                <p-checkbox name="group2" value="deliveryStatuses.PickedUp" [value]="deliveryStatuses.PickedUp" [(ngModel)]="selectedDeliveryStatuses" inputId="deliveryStatuses.PickedUp"></p-checkbox>
                <label for="deliveryStatuses.PickedUp">To destination</label>
            </div>
        </div>
    </p-scrollPanel>

    <hr class="hr-filter"/>
    <div class="flex justify-content-end mrg-10-0px">
        <button class="btn-darkblue" pButton label="Apply filter" (click)="clickFilter()"></button>
    </div>
</div>
